import { Editor, Transforms, Element } from 'slate';


const insertInlineElement = (editor, element, path) => {
  const insertPath = path?[...path, 0]:path
  try {
    Transforms.insertNodes(editor, element, { at: insertPath });
  } catch (e) {
    Transforms.insertNodes(editor, element, { at: path });
  }
};

const insertLeafElement = (editor, element, path) => {
  const {text, ...attrs} = element
  Transforms.insertText(editor, text, { ...attrs });
};

const safeInsertElement = ({ editor, element, parentType, path }) => {
  let parentEntry = null

  try {
    const node = Node.get(editor, path)
    if (Element.isElement(node) && node.type === parentType) {
      parentEntry = [node, path]
    }
  } catch (e) {
    // Path might not exist; ignore
  }

  if (!parentEntry) {
    parentEntry = Editor.above(editor, {
      at: path,
      match: n => Element.isElement(n) && n.type === parentType,
    })
  }

  if (!parentEntry) return // can't insert without a valid parent

  const [parentNode, parentPath] = parentEntry
  
  const insertIndex = parentNode.children?.length || 0;
  const insertPath = [...parentPath, insertIndex];

  Transforms.insertNodes(editor, element, { at: insertPath })
}

const insertElement = (editor, path, type) => {
  console.log(path)
  switch (type) {
    case 'link':
      insertInlineElement(editor, {
        type: 'link',
        url: 'https://',
        children: [{ text: 'linktext' }],
      }, path);
      return;
    case 'image':
      insertInlineElement(editor, {
        type: 'image',
        url: 'https://admin.dev3.book.world/img/placeholder_img.jpg',
        children: [{ text: '' }],
      }, path);
      return;
    case 'table':
      insertInlineElement(editor, {
        type: 'table',
        width: '100%',
        cellSpacing: null,
        cellPadding: null,
        border: null,
        style: null,
        children: [{
          type: 'tablebody',
          children: [{
            type: 'tablerow',
            children: [{
              type: 'tablecell',
              width: null,
              style: null,
              align: null,
              colSpan: null,
              rowSpan: null,
              children: [{
                text: 'table cell'
              }],
            }],
          }],
        }],
      }, path);
      return;
    case 'tablerow':
      safeInsertElement({
        editor, 
        element: {
          type: 'tablerow',
          children: [{
            type: 'tablecell',
            width: null,
            style: null,
            align: null,
            colSpan: null,
            rowSpan: null,
            children: [{
              text: 'table cell'
            }],
          }],
        },
        parentType: 'table', path: path
      });
      return;
    case 'tablehead':
      safeInsertElement({
        editor, 
        element: {
          type: 'tablehead',
          width: null,
          style: null,
          align: null,
          colSpan: null,
          rowSpan: null,
          children: [{
            text: 'table head'
          }],
        },
        parentType: 'tablerow', path: path
      });
      return;
    case 'tablecell':
      safeInsertElement({
        editor, 
        element: {
          type: 'tablecell',
          width: null,
          style: null,
          align: null,
          colSpan: null,
          rowSpan: null,
          children: [{
            text: 'table cell'
          }],
        },
        parentType: 'tablerow', path: path
      });
      return;
    case 'paragraph':
      insertInlineElement(editor, {
        type: 'paragraph',
        align: 'left',
        children: [{ text: 'Paragraph' }],
      }, path);
      return;
    case 'div':
      insertInlineElement(editor, {
        type: 'div',
        class: null,
        style: null,
        children: [{ text: 'div' }],
      }, path);
      return;
    case 'span':
      insertInlineElement(editor, {
        type: 'span',
        class: null,
        style: null,
        children: [{ text: 'span' }],
      }, path);
      return;
    case 'quote':
      insertInlineElement(editor, {
        type: 'quote',
        children: [{ text: 'A quote.' }],
      }, path);
      return;
    case 'font':
      console.log("insert font start")
      insertInlineElement(editor, {
        type: 'font',
        face: 'Helvetica',
        size: '3',
        children: [{ text: 'formatted text' }],
      }, path);
      console.log("insert font end")
      return;
    case 'headingone':
      insertInlineElement(editor, {
        type: 'headingone',
        children: [{ text: 'H1' }],
      }, path);
      return;
    case 'headingtwo':
      insertInlineElement(editor, {
        type: 'headingtwo',
        children: [{ text: 'H2' }],
      }, path);
      return;
    case 'headingthree':
      insertInlineElement(editor, {
        type: 'headingthree',
        children: [{ text: 'H3' }],
      }, path);
      return;
    case 'headingfour':
      insertInlineElement(editor, {
        type: 'headingfour',
        children: [{ text: 'H4' }],
      }, path);
      return;
    case 'headingfive':
      insertInlineElement(editor, {
        type: 'headingfive',
        children: [{ text: 'H5' }],
      }, path);
      return;
    case 'headingsix':
      insertInlineElement(editor, {
        type: 'headingsix',
        children: [{ text: 'H6' }],
      }, path);
      return;
    case 'numberedlist':
      insertInlineElement(editor, {
        type: 'numberedlist',
        children: [{ 
          type: 'listitem',
          children: [{ text: 'list item' }],
        }],
      }, path);
      return;
    case 'bulletedlist':
      insertInlineElement(editor, {
        type: 'bulletedlist',
        children: [{ 
          type: 'listitem',
          children: [{ text: 'list item' }],
        }],
      }, path);
      return;
    case 'listitem':
      insertInlineElement(editor, {
        type: 'listitem',
        children: [{ text: 'list item' }],
      }, path);
      return;
    case 'hr':
      insertInlineElement(editor, {
        type: 'hr',
        size: null,
        children: [{ text: '' }],
      }, path);
      return;
    case 'var':
      insertInlineElement(editor, {
        type: 'var',
        children: [{ text: 'hostel_name', var: true }],
      }, path);
      return;
    case 'br':
      insertLeafElement(editor, {
        br: true,
        text: ''
      }, path);
      return;
    default:
      return;
  }
};


export { insertElement }